import React from 'react';
import { Menu, Space, Tooltip, Typography } from 'antd';
import {
  ThunderboltOutlined,
  RobotOutlined,
  FormOutlined,
  SendOutlined,
  MailOutlined,
  BranchesOutlined,
  FileAddOutlined,
  BarChartOutlined,
  FileTextOutlined,
  FileSearchOutlined,
  FontSizeOutlined,
  LineChartOutlined,
  SearchOutlined,
  FireOutlined,
  FileDoneOutlined,
  UserOutlined,
  MessageOutlined,
  ApiOutlined,
  PictureOutlined,
} from '@ant-design/icons';

const { SubMenu } = Menu;
const { Text } = Typography;

const ViewerSidebar = ({ darkMode, onDragStart }) => {
  const colors = {
    background: darkMode ? '#1f1f1f' : '#ffffff',
    border: darkMode ? '#333333' : '#f0f0f0',
    text: darkMode ? '#ffffff' : '#000000',
    menuBackground: darkMode ? '#141414' : '#ffffff',
  };

  return (
    <div className="workflow-viewer-sidebar" style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '100%',
      width: '200px',
      borderRight: `1px solid ${colors.border}`,
      background: colors.background,
      color: colors.text
    }}>
      <div className="sidebar-scroll" style={{ flex: 1, overflowY: 'auto' }}>
        <Menu 
          mode="vertical" 
          style={{ 
            width: '100%',
            border: 'none',
            background: colors.menuBackground,
            color: colors.text
          }}
          theme={darkMode ? 'dark' : 'light'}
        >
          <Menu.Item 
            key="trigger" 
            icon={<ThunderboltOutlined />} 
            draggable 
            onDragStart={(event) => onDragStart(event, 'trigger')}
          >
            Trigger
          </Menu.Item>

          <SubMenu key="aiActions" icon={<RobotOutlined />} title="AI Actions">
            <Menu.Item key="aiModel" icon={<RobotOutlined />} draggable onDragStart={(event) => onDragStart(event, 'aiModel')}>
              AI Model
            </Menu.Item>
            <Menu.Item key="sentimentAnalysis" icon={<BarChartOutlined />} draggable onDragStart={(event) => onDragStart(event, 'sentimentAnalysis')}>
              Sentiment Analysis
            </Menu.Item>
            <Menu.Item key="summaryGenerator" icon={<FileTextOutlined />} draggable onDragStart={(event) => onDragStart(event, 'summaryGenerator')}>
              Summary Generator
            </Menu.Item>
            <Menu.Item key="extractInformation" icon={<FileSearchOutlined />} draggable onDragStart={(event) => onDragStart(event, 'extractInformation')}>
              Extract Information
            </Menu.Item>
            <Menu.Item key="writeArticle" icon={<FontSizeOutlined />} draggable onDragStart={(event) => onDragStart(event, 'writeArticle')}>
              Write an Article
            </Menu.Item>
            <Menu.Item key="optimizeSEO" icon={<LineChartOutlined />} draggable onDragStart={(event) => onDragStart(event, 'optimizeSEO')}>
              Optimize for SEO
            </Menu.Item>
            <Menu.Item key="research" icon={<SearchOutlined />} draggable onDragStart={(event) => onDragStart(event, 'research')}>
              Research 
            </Menu.Item>
          </SubMenu>

          <Menu.Item key="firecrawl" icon={<FireOutlined />} draggable onDragStart={(event) => onDragStart(event, 'firecrawl')}>
            Web Scraper
          </Menu.Item>

          <Menu.Item key="parser" icon={<FileDoneOutlined />} draggable onDragStart={(event) => onDragStart(event, 'parser')}>
            Parser
          </Menu.Item>

          <Menu.Item key="humanInput" icon={<UserOutlined />} draggable onDragStart={(event) => onDragStart(event, 'humanInput')}>
            Human Input
          </Menu.Item>

          <Menu.Item key="post" icon={<FileAddOutlined />} draggable onDragStart={(event) => onDragStart(event, 'post')}>
            Create Post
          </Menu.Item>

          <Menu.Item key="unsplash" icon={<PictureOutlined />} draggable onDragStart={(event) => onDragStart(event, 'unsplash')}>
            Unsplash Image
          </Menu.Item>

          <Menu.Item key="sendEmail" icon={<MailOutlined />} draggable onDragStart={(event) => onDragStart(event, 'sendEmail')}>
            Send Email
          </Menu.Item>

          <Menu.Item key="condition" icon={<BranchesOutlined />} draggable onDragStart={(event) => onDragStart(event, 'condition')}>
            Condition
          </Menu.Item>

          <Menu.Item key="chat" icon={<MessageOutlined />} draggable onDragStart={(event) => onDragStart(event, 'chat')}>
            Chatbot
          </Menu.Item>

          <Menu.Item key="APICall" icon={<ApiOutlined />} draggable onDragStart={(event) => onDragStart(event, 'APICall')}>
            API Call
          </Menu.Item>

          <Menu.Item key="output" icon={<SendOutlined />} draggable onDragStart={(event) => onDragStart(event, 'output')}>
            Output
          </Menu.Item>
        </Menu>
      </div>

      <div style={{ 
        padding: '16px', 
        borderTop: `1px solid ${colors.border}`,
        backgroundColor: colors.background,
        textAlign: 'center'
      }}>
        <Text type="secondary" style={{ fontSize: '12px' }}>
          Drag nodes to create your workflow
        </Text>
      </div>
    </div>
  );
};

export default ViewerSidebar;